import { render, staticRenderFns } from "./CouponPayment.vue?vue&type=template&id=2c715402"
import script from "./CouponPayment.vue?vue&type=script&lang=js"
export * from "./CouponPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports